/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconDirection = createReactComponent("outline", "direction", "IconDirection", [["path", { "d": "M9 10l3 -3l3 3", "key": "svg-0" }], ["path", { "d": "M9 14l3 3l3 -3", "key": "svg-1" }]]);

export { IconDirection as default };
//# sourceMappingURL=IconDirection.mjs.map
